export default "__VITE_ASSET__B_qoqGr8__"